import Vue from "vue"
import Raven from "raven-js"
import RavenVue from "raven-js/plugins/vue"
import Router from "vue-router"
import routerConfig from "./router/route"
import App from "./components/App.vue"
import store from "./store/index"
import * as userApi from "./api/user"
import * as mqqApi from "./api/mqq"
import { DatePicker, createAPI, Upload } from "cube-ui"
import { getParam } from "@tencent/midas-util"
import installComponent from "./installs/installComponent"

Vue.use(installComponent)
Raven.config("https://f96ffcb87ad041e9804393a7b17c9f08@report.url.cn/sentry/927", {
  environment: process.env.NODE_ENV,
  release: process.env.VERSION,
  dataCallback(data) {
    if (process.env.NODE_ENV !== "production") {
      console.log(data)
    }
    return data
  },
  shouldSendCallback() {
    return process.env.NODE_ENV === "production"
  }
})
  .addPlugin(RavenVue, Vue)
  .install()

Vue.use(Router)
let router = new Router(routerConfig)
Vue.use(DatePicker)
Vue.use(Upload)

router.beforeEach((to, from, next) => {
  //IOS QQ内title刷新
  if (to.meta.title && document.title !== to.meta.title) {
    document.title = to.meta.title
    if (userApi.isQQ() && userApi.isIOS()) {
      mqqApi.refreshTitle()
    }
  }

  //部分路由不可直接进入
  const cannotRedirectRoute = ["invoiceTitle", "applyResult"]
  if (cannotRedirectRoute.indexOf(to.name) >= 0 && from.path === "/") {
    if (getParam("_sp") == 1) {
      next({ path: "/specialInvoiceTitle" })
    } else {
      next({ path: "/select" })
    }
  }
  next()
})

new Vue({
  el: "#app",
  router: router,
  render: h => h(App),
  store: store
})
